<template>
  <form>
    <div class="row">
      <!--<div class="col-lg-12">
        <base-alert type="warning" dismissible>
          {{$t('medium_grant.technical__1_editable_version')}}
          <div class="mt-2">
            <a :href="downloadFiles[$i18n.locale]" class="link-download-white" target="_blank">{{$t('medium_grant.technical__1_editable_version_download')}}
              <img class="ml-2" width="25" src="/img/icons/doc-white.png"> </a>
          </div>
        </base-alert>
      </div>-->
    </div>
    <div class="row mt-3">
      <div class="col-lg-4">
        <h4 class="card-title">{{$t('medium_grant.technical__1_overview')}}</h4>
        <div class="form-group disable-tag">
          <label>{{$t('medium_grant.technical__1_title_of_project')}}</label>
          <textarea
            class="form-control"
            name="technical.titleOfProject"
            v-model="GrantForm.title"
            :error="getError('technical.titleOfProject')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_title_of_project')"
            :label="$t('medium_grant.technical__1_title_of_project')"
            :placeholder="$t('medium_grant.technical__1_title_of_project')"
          >
          </textarea>
        </div>
        <div class="form-group disable-tag">
          <label for="regionSelect">{{$t('medium_grant.technical__1_region')}}</label> <select class="form-control"
                                                                                               @change="setRegion"
                                                                                               name="technical.region"
                                                                                               id="regionSelect"
                                                                                               :error="getError('technical.region')"
                                                                                               v-validate="'required'"
                                                                                               :data-vv-as="$t('medium_grant.technical__1_region')"
                                                                                               disabled
        >
          <option value="" selected="selected">{{$t('medium_grant.general__please_select')}}</option>
          <option :value="region.regionId" :selected="GrantForm.regionId === region.regionId" v-for="region in regions" :key="region.regionId">{{region.code}} - {{region.name}}</option>
        </select>
          <label v-if="getError('technical.region')" class="error text-danger">{{getError('technical.region')}}</label>
        </div>
        <div class="form-group disable-tag" :class="{'has-danger': getError('technical.acpCountry')}">
          <label for="countrySelect">{{$t('medium_grant.technical__1_acp_country')}}</label>
          <multiselect name="technical.acpCountry" v-model="GrantForm.revisionModel.technical.acpCountry" selectLabel="" selectedLabel="" deselectLabel="Clear" v-validate="'required'" :data-vv-as="$t('medium_grant.technical__1_acp_country')" :tag-placeholder="$t('medium_grant.general__please_select')" :placeholder="$t('medium_grant.general__please_select')" label="name" track-by="countryId" :options="countriesByRegion" :multiple="true"></multiselect>
          <label v-if="getError('technical.acpCountry')" class="error text-danger">{{getError('technical.acpCountry')}}</label>
        </div>

        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__1_priority_landscape')}}</label>
          <textarea
            class="form-control"
            name="technical.priorityLandscape"
            v-model="GrantForm.revisionModel.technical.priorityLandscape"
            :error="getError('technical.priorityLandscape')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_priority_landscape')"
            :label="$t('medium_grant.technical__1_priority_landscape')"
            :placeholder="$t('medium_grant.technical__1_priority_landscape')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">Registration number of the PA(s)</label>
          <textarea
            class="form-control"
            name="technical.paTarget"
            v-model="GrantForm.revisionModel.technical.paTarget"
            :error="getError('technical.paTarget')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_pa_target')"
            :label="$t('medium_grant.technical__1_pa_target')"
            :placeholder="$t('medium_grant.technical__1_pa_target')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">PA(s) supervisory authority</label>
          <textarea
            class="form-control"
            name="technical.paSupervisory"
            v-model="GrantForm.revisionModel.technical.paSupervisory"
            :error="getError('technical.paSupervisory')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_pa_supervisory')"
            :label="$t('medium_grant.technical__1_pa_supervisory')"
            :placeholder="$t('medium_grant.technical__1_pa_supervisory')"
          >
          </textarea>
        </div>
        <div class="mb-3">
          <!--<p>{{$t('medium_grant.technical__1_pa_supervisory_upload')}}</p>-->
          <p>{{$t('medium_grant.technical_upload_letter_support')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionSupervisoryUpload" :file-data="GrantForm.files.technical.revisionSupervisoryUpload" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionSupervisoryUpload"></upload-file>
        </div>
        <div class="form-group ">
          <label for="countrySelect">{{$t('medium_grant.technical__1_name_lead_org')}}</label>
          <textarea
            class="form-control"
            name="technical.nameOfLeadOrg"
            v-model="GrantForm.revisionModel.technical.nameOfLeadOrg"
            :error="getError('technical.nameOfLeadOrg')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_name_lead_org')"
            :label="$t('medium_grant.technical__1_name_lead_org')"
            :placeholder="$t('medium_grant.technical__1_name_lead_org')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="countrySelect">{{$t('medium_grant.technical__1_name_of_co_app')}}</label>
          <textarea
            class="form-control"
            name="technical.nameOfCoApplicants"
            v-model="GrantForm.revisionModel.technical.nameOfCoApplicants"
            :label="$t('medium_grant.technical__1_name_of_co_app')"
            :placeholder="$t('medium_grant.technical__1_name_of_co_app')"
          >
          </textarea>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input
              name="technical.startDate"
              v-model="GrantForm.revisionModel.technical.startDate"
              :error="getError1('technical.startDate')"
              v-validate="'required'"
              :data-vv-as="$t('medium_grant.technical__1_startdate')"
              :placeholder="$t('medium_grant.technical__1_startdate')"
            >
              <label>{{$t('medium_grant.technical__1_startdate')}}</label>
              <el-date-picker
                type="date"
                v-model="startDate"
                :placeholder="$t('medium_grant.technical__1_startdate')"
              >
              </el-date-picker>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              name="technical.endDate"
              v-model="GrantForm.revisionModel.technical.endDate"
              :placeholder="$t('medium_grant.technical__1_enddate')"
              :error="getError2('technical.endDate')"
              v-validate="'required'"
              :data-vv-as="$t('medium_grant.technical__1_enddate')"
            >
              <label>{{$t('medium_grant.technical__1_enddate')}}</label>
              <el-date-picker
                type="date"
                v-model="endDate"
                :placeholder="$t('medium_grant.technical__1_enddate')"
              >
              </el-date-picker>
            </base-input>
          </div>
        </div>
        <div class="form-group ">
          <label for="countrySelect">{{$t('medium_grant.technical__1_duration')}} (in months)</label>
          <textarea
            class="form-control"
            name="technical.duration"
            v-model="GrantForm.revisionModel.technical.duration"
            :error="getError('technical.duration')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_duration')"
            :label="$t('medium_grant.technical__1_duration')"
            :placeholder="$t('medium_grant.technical__1_duration')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="countrySelect">{{$t('medium_grant.technical__1_total_budget')}} (in EUR)</label>
          <textarea
            class="form-control"
            name="technical.totalBudget"
            v-model="GrantForm.revisionModel.technical.totalBudget"
            :error="getError('technical.totalBudget')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_total_budget')"
            :label="$t('medium_grant.technical__1_total_budget')"
            :placeholder="$t('medium_grant.technical__1_total_budget')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="countrySelect">{{$t('medium_grant.technical__1_total_funding')}} (in EUR)</label>
          <textarea
            class="form-control"
            name="technical.totalFunding"
            v-model="GrantForm.revisionModel.technical.totalFunding"
            :error="getError('technical.totalFunding')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_total_funding')"
            :label="$t('medium_grant.technical__1_total_funding')"
            :placeholder="$t('medium_grant.technical__1_total_funding')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="countrySelect">{{$t('medium_grant_cn.total_funding_requested')}}</label>
          <textarea
            class="form-control"
            name="technical.totalCoFunding"
            v-model="GrantForm.revisionModel.technical.totalCoFunding"
            v-on:change="totalCoFunding(GrantForm.revisionModel.technical.totalCoFunding)"
            :error="getError('technical.totalCoFunding')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_total_cofunding')"
            :label="$t('medium_grant.technical__1_total_cofunding')"
            :placeholder="$t('medium_grant_cn.total_funding_requested')"
          >
          </textarea>
        </div>
      </div>
      <div class="col-lg-4">
        <h6>
          {{$t('medium_grant.technical__1_biopama_action')}}
        </h6>
        <div class="mt-4 form-group ">
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.technical.enhaceManagement">
          {{$t('medium_grant.technical__1_enhace_management')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.technical.enforceLegal">
          {{$t('medium_grant.technical__1_enforce_legal')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.technical.supportLocal">
          {{$t('medium_grant.technical__1_support_local')}}
        </base-checkbox>
        </div>
        <div class="mt-4"></div>
        <div>
          <label>{{$t('medium_grant.technical__1_priorities_for_action')}}</label>
        </div>
        <div>
          <label>{{$t('medium_grant.technical__1_priorities_for_action_sub')}}</label>
        </div>
        <textarea
          class="form-control"
          :placeholder="$t('medium_grant.technical__1_please_indicate')"
          v-model="GrantForm.revisionModel.technical.indicatePriorities"
        >
        </textarea>
        <div class="mt-4 form-group ">
          <label class="mb-3">{{$t('medium_grant.technical__1_project_enable_data_sharing')}}</label>
          <radio name="organisationType"
                 inline
                 :value="true"
                 v-model="GrantForm.revisionModel.technical.enableDataSharing"
          >
            {{$t('medium_grant.technical__1_project_enable_data_sharing_yes')}}
          </radio>
          <radio name="organisationType" inline :value="false" v-model="GrantForm.revisionModel.technical.enableDataSharing">
            {{$t('medium_grant.technical__1_project_enable_data_sharing_no')}}
          </radio>
        </div>
        <div class="mt-4"></div>
               <h6>
          {{$t('medium_grant.technical__1_reference_doc')}}
        </h6>
        <div class="mt-4"></div>
        <div class=""> 
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.technical.managementGov">
          {{$t('medium_grant_cn.technical__1_quantified_management')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.technical.strategicDoc">
          {{$t('medium_grant_cn.technical__1_quantified_governance')}}
        </base-checkbox>
      </div>
        <!--<div class="mb-3">
          <textarea class="form-control" :placeholder="'Upload diagnostic tool file'" :file-data="GrantForm.files.technical.supervisoryUpload" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" section="technical.supervisoryUpload">

          </textarea>
        </div>-->
        <div class="mt-2"></div>
        <p>Upload diagnostic tool file</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionDiagnosticToolDoc" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionDiagnosticToolDoc" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionDiagnosticToolDoc"></upload-file>
      </div>
      
      <div class="col-lg-4">
        <h4 class="card-title">{{ $t('monitoring.field_title_keyword_for_better_identifying_your_project') }}</h4>
        <div class="mt-4"></div>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_type_of_priority_area') }}</h5>
        <div class="form-group ">
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.typeOfPriorityKeywordMarineProtectedConservedArea"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_marine_protected_conserved_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.typeOfPriorityKeywordMarineManagedAreas"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_marine_managed_areas') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.typeOfPriorityKeywordTerrestrialProtectedConservedArea"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_terrestrial_protected_conserved_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.typeOfPriorityKeywordIndigenousAndCommunityConservedArea"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_indigenous_and_community_conserved_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.typeOfPriorityKeywordPrivatelyProtectedArea"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_privately_protected_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.typeOfPriorityKeywordConservancy"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_conservancy') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.typeOfPriorityKeywordKeyLandscapeForConservation"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_key_landscape_for_conservation') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.typeOfPriorityKeywordKbas"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_KBAs') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.typeOfPriorityKeywordTransboundaryAreas"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_transboundary_areas') }}
            </base-checkbox>
        </div>
  <div class="mt-4"></div>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_primary_objective') }}</h5>
        <div class="form-group ">
            <radio name="model.frequency"
                value="governance"
                v-model="GrantForm.revisionModel.technical.keywordPrimaryObjective"
                >
                <label>{{ $t('monitoring.field_primary_objective_keyword_governance') }}</label>
            </radio>
            <radio name="model.frequency"
                value="management_effectiveness"
                v-model="GrantForm.revisionModel.technical.keywordPrimaryObjective"
                >
                <label>{{ $t('monitoring.field_primary_objective_keyword_management_effectiveness') }}</label>
            </radio>
            <radio name="model.frequency"
                value="livelihoods"
                v-model="GrantForm.revisionModel.technical.keywordPrimaryObjective"
                >
                <label>{{ $t('monitoring.field_primary_objective_keyword_livelihoods') }}</label>
            </radio>
        </div>
        <div class="mt-4"></div>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_target_groups') }}</h5>
        <div class="form-group ">
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.targetGroupsKeywordLocalCommunities"
                >
                {{ $t('monitoring.field_target_groups_keyword_local_communities') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.targetGroupsKeywordIndigenousPpeople"
                >
                {{ $t('monitoring.field_target_groups_keyword_indigenous_people') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.targetGroupsKeywordYouth"
                >
                {{ $t('monitoring.field_target_groups_keyword_youth') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.targetGroupsKeywordWomen"
                >
                {{ $t('monitoring.field_target_groups_keyword_women') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.targetGroupsKeywordPrivateSector"
                >
                {{ $t('monitoring.field_target_groups_keyword_private_sector') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.targetGroupsKeywordFarmersFishermen"
                >
                {{ $t('monitoring.field_target_groups_keyword_farmers_fishermen') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.targetGroupsKeywordNationalLocalPaAgency"
                >
                {{ $t('monitoring.field_target_groups_keyword_national_local_pa_agency') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.targetGroupsKeywordNationalGovernment"
                >
                {{ $t('monitoring.field_target_groups_keyword_national_government') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.targetGroupsKeywordSubnationalGovernments"
                >
                {{ $t('monitoring.field_target_groups_keyword_subnational_governments') }}
            </base-checkbox>
        </div>
        <div class="mt-4"></div>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_main_activity_focus') }}</h5>
        <div class="form-group  row">
            <div class="col-6">
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordManagementPlan"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_management_plan') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordEnforcement"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_enforcement') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordLegalFrameworkRegulation"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_legal_framework_regulation') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordIllegalActivities"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_illegal_activities') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordCoManagement"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_co_management') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordParticipation"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_participation') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordLivelihoodsAlternativeEconomicActivities"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_livelihoods_alternative_economic_activities') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordSustainableDevelopment"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_sustainable_development') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordLandscapeApproach"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_landscape_approach') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordEcoTourism"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_eco_tourism') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordSustainableFinancing"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_sustainable_financing') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordThreatenedSpecies"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_threatened_species') }}
                </base-checkbox>
            </div>
<div class="mt-4"></div>
            <div class="col-6">
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordHumanWildlifeConflict"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_human_wildlife_conflict') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordEcosystemHabitatRestoration"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_ecosystem_habitat_restoration') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordInvasiveAlienSpecies"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_invasive_alien_species') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordSurveyDataKnowledgeManagement"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_survey_data_knowledge_management') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordProtectedAreaManagementEffectivenessPame"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_protected_area_management_effectiveness_pame') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordProtectedAreaGovernanceEffectivenessPage"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_protected_area_governance_effectiveness_page') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordCapacityBuilding"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_capacity_building') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordAwarenessEducation"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_awareness_education') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordClimateAdaptationMitigationResilience"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_climate_adaptation_mitigation_resilience') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordMnitoringPatrolEquipment"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_monitoring_patrol_equipment') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordHumanRights"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_human_rights') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.revisionModel.technical.fieldMainActivityFocusKeywordGreenList"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_green_list') }}
                </base-checkbox>
            </div>
        </div>
<div class="mt-4"></div>
        <h4 class="card-title">{{ $t('monitoring.field_title_support_to_local_communities') }}</h4>
        <div class="form-group ">
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordA"
                >
                {{ $t('monitoring.field_support_keyword_01') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordB"
                >
                {{ $t('monitoring.field_support_keyword_02') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordC"
                >
                {{ $t('monitoring.field_support_keyword_03') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordD"
                >
                {{ $t('monitoring.field_support_keyword_04') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordE"
                >
                {{ $t('monitoring.field_support_keyword_05') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordF"
                >
                {{ $t('monitoring.field_support_keyword_06') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordG"
                >
                {{ $t('monitoring.field_support_keyword_07') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordH"
                >
                {{ $t('monitoring.field_support_keyword_08') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordI"
                >
                {{ $t('monitoring.field_support_keyword_09') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordJ"
                >
                {{ $t('monitoring.field_support_keyword_10') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordK"
                >
                {{ $t('monitoring.field_support_keyword_11') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordL"
                >
                {{ $t('monitoring.field_support_keyword_12') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordM"
                >
                {{ $t('monitoring.field_support_keyword_13') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.revisionModel.technical.supportKeywordN"
                >
                {{ $t('monitoring.field_support_keyword_14') }}
            </base-checkbox>
        </div>
      </div>
      
    </div>
  </form>
</template>
<script>
  import {DatePicker} from 'element-ui';
  import Multiselect from 'vue-multiselect';
  import {GrantForm, RegionService} from "@/services";
  import {BaseAlert} from 'src/components';

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      Multiselect,
      BaseAlert
    },
    data() {
      return {
        GrantForm,
        startDate: '',
        endDate: '',
        moment: '',
        regions: [],
        options: [],
        value: [],
        downloadFiles: {
          en: '/files/en/Application_template_BIOPAMA_medium_grants_2019_EN.docx',
          fr: '/files/fr/Application_template_BIOPAMA_medium_grants_2019_FR.docx'
        }
      }
    },
    computed: {
      countriesByRegion() {
        let countries = [];
        let region = this.regions.filter((region) => {
          return region.regionId === GrantForm.regionId;
        })
        if (region[0] !== undefined && region[0].countries !== undefined && region[0].countries.length) {
          countries = region[0].countries;
        }
        return countries;
      }
    },
    async beforeMount() {
      this.moment = require('moment');

      let loader = this.$loading.show();
      let vm = this;
      RegionService.getApplicationRegionsWithCountries().then(function (response) {
        vm.regions = response.data;

        loader.hide();
      })

      if (GrantForm.revisionModel.technical.startDate !== undefined) {
        this.startDate = GrantForm.revisionModel.technical.startDate;
      }

      if (GrantForm.revisionModel.technical.endDate !== undefined) {
        this.endDate = GrantForm.revisionModel.technical.endDate;
      }
      /*if(this.GrantForm.model.technical){
        this.GrantForm.model.technical = this.GrantForm.model.technical;
      }*/
    },
    methods: {
      totalCoFunding(newValue){
        if(GrantForm.regionId == 5 || GrantForm.regionId == 6){
          var allowedPercentage = 100;
          var maxAmount = 200000;
        }
        else if(GrantForm.regionId == 3 || GrantForm.regionId == 4){
          var allowedPercentage = 95;
          var maxAmount = 200000;
        }
        else if(GrantForm.regionId == 1){
          var allowedPercentage = 95;
          var maxAmount = 400000;
        }
        GrantForm.revisionModel.technical.totalCoFunding = (newValue <= (GrantForm.revisionModel.technical.totalFunding*allowedPercentage)/100) && (newValue <= maxAmount) ? newValue : null;
        
        //GrantForm.model.cndescription.totalCoFunding = newValue <= (GrantForm.model.cndescription.totalFunding*GrantForm.budgetPercentage)/100 ? newValue : null;
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      getError2(field)
            {
                // if(this.errors.first(field)){
                //     return 'End Date should be greater than Start Date';
                // }
                // else{
                //     return this.errors.first(field);
                // }
                
            },
      getError1(field)
            {
                // if(this.errors.first(field)){
                //     return 'Start Date cannot be a past date';
                // }
                // else{
                //     return this.errors.first(field);
                // }
                
            },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      setRegion(event) {
        GrantForm.regionId = parseInt(event.target.value);
        GrantForm.revisionModel.technical.acpCountry = [];
      }
    },
    watch: {
      startDate(newValue, oldValue) {
        //GrantForm.revisionModel.technical.startDate = this.moment(newValue).format('YYYY-MM-DD');
        const date = this.moment(newValue).format('YYYY-MM-DD');
        //const currentDate = this.moment(new Date()).format('YYYY-MM-DD');
                //GrantForm.revisionModel.technical.startDate = (date === 'Invalid date') ? null : (date >= currentDate ? date : null);
                GrantForm.revisionModel.technical.startDate = date;
      },
      endDate(newValue, oldValue) {
        //GrantForm.revisionModel.technical.endDate = this.moment(newValue).format('YYYY-MM-DD');

        const date = this.moment(newValue).format('YYYY-MM-DD');
               // GrantForm.revisionModel.technical.endDate = (date === 'Invalid date') ? null : (date > GrantForm.revisionModel.technical.startDate ? date : null);
               GrantForm.revisionModel.technical.endDate =date
      },
    }
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }
  
  .disable-tag {
    pointer-events: none;
  }
</style>
